export interface IShareButton {
  title: string;
  icon: string;
  link: (url: string) => string;
  className: string;
  width: number;
  height: number;
}

const ShareState: IShareButton[] = [
  {
    title: 'Twitter',
    icon:
      '<svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
      '<circle cx="22" cy="22" r="21.5" fill="#024D40" stroke="#024D40"/>\n' +
      '<path d="M27.8014 13H30.867L24.136 20.6384L32 31H25.8287L20.997 24.7033L15.4655 31H12.3999L19.5308 22.8303L12 13H18.3246L22.6898 18.752L27.8014 13ZM26.7284 29.2066H28.4279L17.4315 14.7269H15.6055L26.7284 29.2066Z" fill="white"/>\n' +
      '</svg>',
    link: (url) => {
      return `https://twitter.com/intent/tweet?url=${url}`;
    },
    className: 'container__twitter',
    width: 44,
    height: 44,
  },
  {
    title: 'LinkedIn',
    icon:
      '<svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
      '<circle cx="22" cy="22" r="22" fill="#024D40"/>\n' +
      '<path d="M16.2969 31H12V17.6406H16.2969V31ZM14.2969 15.6094H14.2656C12.8906 15.6094 12 14.5859 12 13.3047C12 12 12.9141 11 14.3203 11C15.7266 11 16.5859 11.9922 16.6172 13.3047C16.6172 14.5859 15.7266 15.6094 14.2969 15.6094ZM32 31H27.7031V23.6953C27.7031 21.9453 27.0781 20.75 25.5234 20.75C24.3359 20.75 23.6328 21.5547 23.3203 22.3359C23.2031 22.6172 23.1719 23 23.1719 23.3906V31H18.875V17.6406H23.1719V19.5C23.7969 18.6094 24.7734 17.3281 27.0469 17.3281C29.8672 17.3281 32 19.1875 32 23.1953V31Z" fill="white"/>\n' +
      '</svg>',
    link: (url) => {
      return `https://linkedin.com/shareArticle?url=${url}`;
    },
    className: 'container__linkedin',
    width: 44,
    height: 44,
  },
  {
    title: 'Facebook',
    icon:
      '<svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
      '<circle cx="22" cy="22" r="22" fill="#024D40"/> \n' +
      '<path d="M26.1628 23.0559L26.7907 19.5776H23.093V17.1553C23.093 16.1615 23.5116 15.4161 25.186 15.4161H27V12.2484C26.0233 12.1242 24.907 12 23.9302 12C20.7209 12 18.4884 13.7391 18.4884 16.8447V19.5776H15V23.0559H18.4884V31.8137C19.2558 31.9379 20.0233 32 20.7907 32C21.5581 32 22.3256 31.9379 23.093 31.8137V23.0559H26.1628Z" fill="white"/> \n' +
      '</svg>',
    link: (url) => {
      return `https://www.facebook.com/sharer/sharer.php?u=${url}`;
    },
    className: 'container__facebook',
    width: 44,
    height: 44,
  },
];

export default ShareState;
